import { render, staticRenderFns } from "./MatricesTableActions.vue?vue&type=template&id=53f035c4&scoped=true&"
import script from "./MatricesTableActions.vue?vue&type=script&lang=js&"
export * from "./MatricesTableActions.vue?vue&type=script&lang=js&"
import style0 from "./MatricesTableActions.vue?vue&type=style&index=0&id=53f035c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f035c4",
  null
  
)

export default component.exports